import { render, staticRenderFns } from "./VContractWidget.vue?vue&type=template&id=575e47da&"
import script from "./VContractWidget.vue?vue&type=script&lang=js&"
export * from "./VContractWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports